import { render } from "./ProjectSearch.vue?vue&type=template&id=17855461&scoped=true&ts=true"
import script from "./ProjectSearch.vue?vue&type=script&lang=ts"
export * from "./ProjectSearch.vue?vue&type=script&lang=ts"

import "./ProjectSearch.vue?vue&type=style&index=0&id=17855461&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17855461"]])

export default __exports__